import React, { useEffect, useState } from 'react';
import './Stock.css'; 
import {ContactForm} from "./ContactForm";
import Meta from './Meta';

const API_URL = 'https://api.itosoba.ru/api/stocks';

function Stock() {
  const [stocks, setStocks] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedStock, setSelectedStock] = useState(null);

  useEffect(() => {
    fetchStocks();
  }, []);

  const fetchStocks = async () => {
    try {
      const response = await fetch(API_URL);
      if (!response.ok) {
        throw new Error('Ошибка загрузки данных');
      }
      const data = await response.json();
      setStocks(data);
    } catch (error) {
      console.error('Ошибка:', error);
    }
  };

  const handleConnectClick = (stock) => {
    setSelectedStock(stock);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedStock(null);
  };

  return (
      <React.Fragment>
    <Meta
        title="Акции и спецпредложения на интернет и IT-услуги от «ИТ Особа»"
        description="Выгодные акции для новых и действующих клиентов! Скидки на подключение интернета и другие спецпредложения. Успейте забрать!"
      />
    <div className="stock-container"  >
      {stocks.length === 0 ? (
        <p className="no-data">Нет данных</p>
      ) : (
        <div className="cards-wrapper" >
          {stocks.map((stock) => (
              <div key={stock.id} className="card">
                <h2 className="card-title">{stock.name}</h2>
                <p className="card-description">{stock.description}</p>
                <div className="button-wrapper" style={{display: 'flex', justifyContent: 'center', marginTop: '10px'}}>
                  {/* <button
                      style={{
                        padding: '12px 24px',
                        width: '170px', 
                        border: 'none',
                        borderRadius: '8px',
                        background: 'linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)',
                        color: '#fff',
                        cursor: 'pointer',
                        fontSize: '14px',
                        marginTop: '10px',
                        boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
                        transition: 'background 0.3s, transform 0.2s, box-shadow 0.3s',
                      }}
                      onClick={() => handleConnectClick(stock)}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = 'linear-gradient(135deg, #6a11cb 0%, #2b7aef 100%)';
                        e.currentTarget.style.transform = 'translateY(-2px)';
                        e.currentTarget.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.3)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = 'linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)';
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.2)';
                      }}
                  >
                    Оставить заявку
                  </button> */}
                  </div>
                </div>
                ))}
              </div>
          )}

          {modalOpen && selectedStock && (
              <div
                  style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
          }}
          onClick={closeModal}
        >
          <div
            style={{
              backgroundColor: '#fff',
              padding: '30px',
              borderRadius: '10px',
              maxWidth: '400px',
              width: '90%',
              boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
              position: 'relative',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                position: 'absolute',
                top: 12,
                right: 12,
                width: 32,
                height: 32,
                cursor: 'pointer',
                borderRadius: '50%',
                backgroundColor: '#f0f0f0',
                color: '#333',
                fontSize: 24,
                fontWeight: 'bold',
                lineHeight: '32px',
                textAlign: 'center',
                boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                transition: 'background-color 0.3s, color 0.3s, box-shadow 0.3s',
              }}
              onClick={closeModal}
              aria-label="Закрыть"
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#e0e0e0';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#f0f0f0';
              }}
            >
              ×
            </div>
            <h3> {selectedStock.name}</h3>
            <ContactForm stock={selectedStock} />
          </div>
        </div>
      )}
    </div>
    </React.Fragment>
  );
}

export default Stock;